// 图片资源映射
// 请将您的本地图片放在 public/images/ 文件夹中，然后修改下面的路径

// 方法1: 使用 public 文件夹中的图片（推荐）
// 图片路径相对于 public 文件夹，例如：public/images/logo.png -> "/images/logo.png"
export const images = {
  // Logo - 顶部导航栏的logo
  logo: "/images/logo.png",
  
  // 介绍页 - 第一屏（咖啡与白鸽）
  intro: "/images/intro.mp4",
  introImage: "/images/intro.jpg", // 手机端使用的静态图片
  
  // 英雄页 - 主视觉（战争孤儿的眼睛）
  hero: "/images/hero.mp4",
  heroImage: "/images/hero.jpg", // 手机端使用的静态图片
  
  // 统计页 - 显示4.73亿儿童
  stats: "/images/stats.mp4",
  statsImage: "/images/stats.jpg", // 手机端使用的静态图片
  
  // 哭泣页 - "我的家在哪里"
  cry: "/images/cry.mp4",
  cryImage: "/images/cry.png", // 手机端使用的静态图片
  
  // 学校页 - "我们的学校成了废墟"
  school: "/images/school.mp4",
  schoolImage: "/images/school.png", // 手机端使用的静态图片
  
  // 父母页 - "爸爸妈妈你们在哪"
  parents: "/images/parents.png",
  
  // 饥饿页 - 两张并列的图片
  hunger1: "/images/hunger1.mp4",
  hunger1Image: "/images/hunger1.png", // 手机端使用的静态图片
  hunger2: "/images/hunger2.mp4",
  hunger2Image: "/images/hunger2.png", // 手机端使用的静态图片
  
  // 时刻页 - "请记住他们"
  moment: "/images/moment.png",
  
  // 过渡页 - 过去与未来对比
  past: "/images/past.png",
  future: "/images/future.png",
  
  // 行动页 - 白鸽计划
  action: "/images/action.mp4",
  actionImage: "/images/action.png", // 手机端使用的静态图片
  
  // 解决方案页 - 善行足迹
  hope: "/images/hope.mp4",
  hopeImage: "/images/hope.png", // 手机端使用的静态图片
  
  // 学校介绍页 - 两张图片
  childrenOutdoor: "/images/children-outdoor.jpg",
  childrenIndoor: "/images/children-indoor.jpg",
  
  // 咖啡页 - 左右分屏
  coffee: "/images/coffee.mp4",
  coffeeImage: "/images/coffee.jpg", // 手机端使用的静态图片
  childSmile: "/images/child-smile.mp4",
  childSmileImage: "/images/child-smile.png", // 手机端使用的静态图片
  
  // 行动号召页
  cta: "/images/cta.mp4",
  ctaImage: "/images/cta.png", // 手机端使用的静态图片

  journey: "/images/journey.mp4",
  journeyImage: "/images/journey.jpg", // 手机端使用的静态图片
};

